export default __webpack_public_path__ + "99482164d2b5292013e8c21bd826bbe4.png";